import ModalBase from 'components/Modal/ModalBase';
import styled from 'styled-components';

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;

  padding: 24px 20px 16px;
`;

const Title = styled.h3`
  margin: 0;
  margin-bottom: 8px;

  font-weight: 600;
  font-size: 20px;
  line-height: 28px;

  color: #1b1c1e;
`;

const Subtitle = styled.p`
  margin: 0;
  margin-bottom: 32px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  color: #70737c;
`;

const Button = styled.button`
  height: 48px;
  width: fit-content;
  padding: 0 24px;

  margin-left: auto;
  border-radius: 12px;

  background-color: #1b1c1e;
  color: #fff;
  line-height: 48px;

  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;

interface Props {
  handleModal: () => void;
}

function ExcelMobileAlert({ handleModal }: Props) {
  return (
    <ModalBase
      isMobile={false}
      handleModal={handleModal}
      useCustomHeader
      // style={{ minHeight: isMobile ? '176px' : '748px' }}
    >
      <ModalBody>
        <Title>모바일에선 엑셀 내려받을 수 없어요</Title>
        <Subtitle>PC 웹 브라우저에서 이용해 주세요.</Subtitle>

        <Button onClick={handleModal}>네, 확인했어요</Button>
      </ModalBody>
    </ModalBase>
  );
}

export default ExcelMobileAlert;
